import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        //? for debug: console.log('CTLUpdate:', payload);

        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const jwtFromCookie = getCookieByName(appCookieKey);
        const sharedCookie = getCookieByName(sharedCookieKey);
        if (jwtFromCookie && sharedCookie) {
            const wholeTokenFromCookie = JSON.parse(sharedCookie);

            let spatFromCookie = wholeTokenFromCookie.spat;

            if (spatFromCookie && jwtFromCookie) {
                let checkResult = await apiClient(config).apiMethod({
                    method: 'CTLUpdate',
                    headers: {
                        'X-Auth-Token': jwtFromCookie,
                        'X-Auth-Spat': spatFromCookie,
                    },
                    args: {
                        firstname: payload.firstname,
                        lastname: payload.lastname,
                        birthdate: payload.birthdate,
                        gender: payload.gender,
                        address: {
                            state: payload.address.state,
                            address1: payload.address.address1,
                            address2: payload.address.address2,
                            city: payload.address.city,
                            zip: payload.address.zip,
                        },
                        phone: payload.phone,
                        email: payload.email,
                        old_password: payload.old_password,
                        password: payload.password,
                        confirm: payload.confirm,
                    },
                });

                // {"code":"_VALIDATION","message":"Input validation error.","data":{"ticket_number":["The ticket number field is required."]},"extended":""}
                if (checkResult.code) {
                    return {
                        success: false,
                        errors: checkResult.code,
                    };
                } else if (checkResult) {
                    return {
                        payload: checkResult,
                        success: true,
                        errors: 'success',
                    };
                } else {
                    return {
                        success: false,
                        errors: ' _UNKNOWN',
                    };
                }
            } else {
                return {
                    success: false,
                    errors: ' _AUTHENTICATION',
                };
            }
        } else {
            return {
                success: false,
                errors: ' _AUTHENTICATION',
            };
        }
    };
};
